import React from 'react';
import moment from 'moment';
import {Popup} from 'semantic-ui-react';
import {shortDate, noTimeZoneFullISODate} from '../common/constants/datesFormat';
import ModalDeviceRequest from './components/RequestsInstallation/modal/deviceRequest';

export const columnsRequestDevice = [
  {
    'Header': 'SOLICITUD',
    'accessor': 'requestId',
  },
  {
    'Header': 'FECHA',
    'accessor': 'creationDate',
    'Cell': ({row}) => moment(row.original.creationDate, noTimeZoneFullISODate).format(shortDate),
  },
  {
    'Header': 'CONCESIONARIO',
    'accessor': 'dealerName',
  },
  {
    'Header': 'CHASIS',
    'accessor': 'chassis',
  },
  {
    'Header': 'KATASHIKI',
    'accessor': 'katashiki',
  },
  {
    'Header': 'MODELO',
    'accessor': 'model',
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      const {requestId, requestType, dealer} = row.original;
      return (
        <Popup
          trigger={<ModalDeviceRequest action="see" requestId={requestId} dealer={dealer} requestType={requestType} />}
          content="Ver Garantía"
          position="top center"
          inverted
        />
      );
    },
  },
];

export const requestsTypeDict = {
  'D': 'DESINSTALACIÓN',
  'R': 'REINSTALACIÓN',
};

export const BASE_FORM_REQUEST_DEVICE = {
  'requestType': 'Tipo  de solicitud',
  'agency': 'Agencia',
  'chassis': 'Chasis',
  'clientName': 'Nombre del cliente',
  'clientId': 'Cedula cliente',
  'phone': 'Celular',
  'sellerName': 'Nombre del vendedor',
  'requestId': 'Numero de Solicitud',
};
